import axios from 'axios';
import * as types from './mutationsType';
import * as Constants from '@/utils/constants';

// eslint-disable-next-line no-unused-vars
export async function login({ commit }, data) {
  try {
    return await axios({
      method: Constants.HTTP_METHODS.POST,
      url: `${Constants.API_URL}/admin/login`,
      headers: {
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

// eslint-disable-next-line no-unused-vars
export async function fetchUserInfo({ commit }, data) {
  try {
    return await axios({
      method: Constants.HTTP_METHODS.GET,
      url: `${Constants.API_URL}/admin/info`,
      headers: {
        token: data.token,
      },
    });
  } catch (e) {
    return e;
  }
}

/**
 * 商店資料
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function getStoreList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}/store/list`,
      headers: {
        token: data.token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 儲存商店資料
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function saveStoreInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}/store/save`,
      headers: {
        token: data.token,
      },
      data: data.info,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 刪除商店資料
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function deleteStoreInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}/store/delete`,
      headers: {
        token: data.token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 所有商品資料目錄
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function getAllProductList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}/product/menu`,
      headers: {
        token: data.token,
      },
      data
    });
  } catch (e) {
    return e;
  }
}

/**
 * 商品資料
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function getProductList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}/product/list`,
      headers: {
        token: data.token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 儲存商品資料
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function saveProductInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}/product/save`,
      headers: {
        token: data.token,
      },
      data: data.info,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 刪除商品資料
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function deleteProductInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}/product/delete`,
      headers: {
        token: data.token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 最新消息
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function getNewsList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}/news/list`,
      headers: {
        token: data.token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 儲存最新消息資料
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function saveNewsInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}/news/save`,
      headers: {
        token: data.token,
      },
      data: data.info,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 刪除最新消息資料
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function deleteNewsInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}/news/delete`,
      headers: {
        token: data.token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 首頁
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function getHomeList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}/home/list`,
      headers: {
        token: data.token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 儲存最新消息資料
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function saveHomeInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}/home/save`,
      headers: {
        token: data.token,
      },
      data: data.info,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 刪除首頁資料
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function deleteHomeInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}/home/delete`,
      headers: {
        token: data.token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 品牌故事
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function getAboutInfo({ commit }, data) {
  try {
    return await axios({
      method: 'get',
      url: `${Constants.API_URL}/about/info`,
      headers: {
      },
    });
  } catch (e) {
    return e;
  }
}

/**
 * 儲存品牌故事
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function saveAboutInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}/about/save`,
      headers: {
        token: data.token,
      },
      data: data.info,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 促銷網頁列表
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function getSalePageList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}/sale/list`,
      headers: {
      },
      data
    });
  } catch (e) {
    return e;
  }
}



/**
 * 促銷網頁內容
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function getSaleInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}/sale/info`,
      headers: {
      },
      data
    });
  } catch (e) {
    return e;
  }
}

/**
 * 儲存促銷網頁內容
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function saveSaleInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}/sale/save`,
      headers: {
        token: data.token,
      },
      data: data.info,
    });
  } catch (e) {
    return e;
  }
}


/**
 * 刪除促銷網頁內容
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function deleteSaleInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}/sale/delete`,
      headers: {
        token: data.token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

/// 合約
// eslint-disable-next-line no-unused-vars
export async function fetchContractList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}/contract/list`,
      data});
  } catch (e) {
    return e;
  }
}

// eslint-disable-next-line no-unused-vars
export function fetchFileList({ commit }) {
  return new Promise((resolve, reject) => {
    const api = `${Constants.API_URL}/users/photos/list`;
    axios.post(api, null)
        .then((response) => {
          const list = Object.values(response.data);
          // console.log(`fetchFileList response ${JSON.stringify(list)}`);
          commit(types.SET_FILE_LIST, list);
          resolve(response.data);
        })
        .catch((error) => {
          console.log(`fetchFileList err ${JSON.stringify(error)}`);
          reject(error);
        });
  });
}

// eslint-disable-next-line no-unused-vars
export function saveFileInfo({ commit }, data) {
  return new Promise((resolve, reject) => {
    const api = `${Constants.API_URL}/users/photos/update`;
    axios.post(api, data)
        .then((response) => {
          console.log(`saveFileInfo response ${JSON.stringify(response)}`);
          resolve(response.data);
        })
        .catch((error) => {
          console.log(`saveFileInfo err ${JSON.stringify(error.data)}`);
          reject(error.data);
        });
  });
}

// 上傳API
// eslint-disable-next-line no-unused-vars
export function uploadFileList({ commit }, data) {
  return new Promise((resolve, reject) => {
    const api = `${Constants.API_URL}/users/photos/upload`;
    // const formData = new FormData();
    // const files = [];
    // data.fileList.forEach((item) => {
    //   files.push(item.image);
    // });
    // formData.append('files[]', files);
    axios.post(api, data.fileList, {
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      transformRequest: [function (data) {
        return data;
      }],
      onUploadProgress(e) {
        const percentage = Math.round((e.loaded * 100) / e.total) || 0;
        if (percentage < 100) {
          console.log(`${percentage}%`); // 上传进度
        }
      },
    }).then((response) => {
      console.log(response); // {code: 200, description: "", detail: null}
      resolve(response);
    }).catch((error) => {
      console.log(`fetchFileList err ${JSON.stringify(error)}`);
      reject(error);
    });
  });
}


/**
 * 儲存會員資料
 * @param commit
 * @param data Object
 * */
export function configUserInfo({ commit }, data) {
  localStorage.setItem(Constants.TOKEN_KEY, data.token);
  commit(types.SET_USER_INFO, data);
}




/**
 * 登出
 * @param commit
 * */
export function logout({ commit }) {
  commit(types.SET_USER_INFO, null);
  localStorage.removeItem(Constants.TOKEN_KEY);
}

/**
 * 儲存匯入的屈臣氏資料
 * @param commit
 * @param data list
 * orderId
 * customName
 * orderDate:yyyy-mm-dd hh:mm:ss
 * shopNo
 * payType
 * shopName
 * phone
 * price
 * */
// eslint-disable-next-line no-unused-vars
export async function saveMultiOrders({commit}, data) {
  
  try {
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}/watsons/saveMultiOrders`,
      headers: {
        token: data.token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 屈臣氏訂單列表
 * @param commit
 * @param data list
 * */
// eslint-disable-next-line no-unused-vars
export async function watsonsList({commit}, data) {
  try {
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}/watsons/list`,
      headers: {
        token: data.token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 屈臣氏訂單明細
 * @param commit
 * @param data list
 * */
// eslint-disable-next-line no-unused-vars
export async function watsonsInfo({commit}, data) {
  try {
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}/watsons/info`,
      headers: {
        token: data.token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}


/**
 * 更新屈臣氏訂單明細
 * @param commit
 * @param data list
 * */
// eslint-disable-next-line no-unused-vars
export async function watsonsSave({commit}, data) {
  try {
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}/watsons/save`,
      headers: {
        token: data.token,
      },
      data: data.info,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 刪除屈臣氏訂單明細
 * @param commit
 * @param data list
 * */
// eslint-disable-next-line no-unused-vars
export async function watsonsDelete({commit}, data) {
  try {
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}/watsons/delete`,
      headers: {
        token: data.token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 建立屈臣氏訂單
 * @param commit
 * @param data 
 * orderId
 * shippingDate
 * shippingNumber
 * */
// eslint-disable-next-line no-unused-vars
export async function watsonsCreate({commit}, data) {
  try {
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}/watsons/createOrder`,
      headers: {
        token: data.token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 屈臣氏退貨
 * @param commit
 * @param data 
 * orderId
 * */
// eslint-disable-next-line no-unused-vars
export async function watsonsRefundsOrder({commit}, data) {
  try {
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}/watsons/refundsOrder`,
      headers: {
        token: data.token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 門市匯入
 * @param commit
 * @param data list
 * */
// eslint-disable-next-line no-unused-vars
export async function saveMultiStore({commit}, data) {
  try {
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}/store/saveMultiStore`,
      headers: {
        token: data.token,
      },
      data,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 櫃位資料
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function getCounterList({ commit }, data) {
  try {
    return await axios({
      method: 'get',
      url: `${Constants.API_URL}/product/counter/list`,
    });
  } catch (e) {
    return e;
  }
}

/**
 * 儲存櫃位
 * @param commit
 * @param data Object
 * */
// eslint-disable-next-line no-unused-vars
export async function saveCounterInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${Constants.API_URL}/product/counter/save`,
      headers: {
        token: data.token,
      },
      data: data.info,
    });
  } catch (e) {
    return e;
  }
}